import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/upload/page.tsx");
